/**
 * set of functions to enforce a data structure
 */
import fieldsToStructure from './fieldsToStructure';

const preservedFields = [
  'id',
  'type',
  'date',
  'post',
  'unread',
];

const notificationStructure = Object.assign(
  fieldsToStructure(preservedFields),
  {
    user(notification) {
      return notification.userId || undefined;
    },
  }
);

export default notificationStructure;



// WEBPACK FOOTER //
// ./~/virgo/src/structures/notificationStructure.js